<template>
    <div class="B2BArticles container relative flex flex-col items-center pb-10 pt-20 text-center xl:pb-20">
        <div class="flex w-full flex-col items-center justify-center gap-6">
            <CHeading tag="h2" variant="fat-italic">Ponuka spolupráce</CHeading>

            <CText class="mt-4 xl:mt-0" variant="muted">
                Vyberte si, ktorý profil vám najviac pomôže naplniť vaše ciele.<br />
                Ceny sú uvedené bez DPH a platné od 25. 7. 2023.<br />

                <CAlert class="mt-3 max-w-[70ch] text-left" icon="info" variant="info">
                    Ak potrebujete okamžite zverejniť pracovnú ponuku, vyberte si akýkoľvek profil okrem FREE. Vaše
                    pracovné ponuky budú hneď online, my sa medzičasom s vami spojíme a dotiahneme finančné záležitosti.
                </CAlert>
            </CText>
        </div>

        <div class="my-10">
            <OrgPaidProfileLevels preview />
        </div>

        <CButton class="relative h-14 w-[248px] sm:mt-0" href="#formular" variant="primary">
            Mám záujem o spoluprácu
        </CButton>
    </div>
</template>

<script setup lang="ts">
import OrgPaidProfileLevels from '@/components/orgs/OrgPaidProfileLevels.vue'
</script>